import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Kanonische Schreibweise der URLs: kleingeschrieben, ohne doppelte Slashes,
 * ohne abschließenden Slash. Bestehende URLs bleiben unverändert — es werden
 * nur abweichende Varianten auf die kanonische Form umgeschrieben.
 */
export function canonicalPath(pathname: string): string {
  let next = pathname.replace(/\/{2,}/g, '/');
  next = next.toLowerCase();
  if (next.length > 1) next = next.replace(/\/+$/, '');
  return next || '/';
}

export const UrlCanonicalizer = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Admin-Routen enthalten UUIDs mit Groß-/Kleinschreibung — nicht anfassen.
    if (pathname.startsWith('/admin')) return;
    const next = canonicalPath(pathname);
    if (next !== pathname) {
      navigate(`${next}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default UrlCanonicalizer;
